






import Vue from 'vue';

// Components
import Loading from './base/Loading.vue';
import Row from './base/Row.vue';

export default Vue.extend({
    components: {
        Row,
        Loading,
    },
});
